module.exports = __webpack_public_path__ + "1d9a1e806f571f5d081a30c329088b81.svg";